/**
 * https://github.kakaocorp.com/kakaopage/api/blob/feature/8.0.0/develop/api/src/main/java/com/kakaopage/api/model/search/enums/SearchFilterSortOption.java#L14
 */
export enum SearchThemeKeywordSortTypeVo {
  /** default: UPDATE */
  Update = 'UPDATE',
  Latest = 'LATEST',
  Popular = 'POPULAR',
  Comment = 'COMMENT',
  Like = 'LIKE',
}
